<template>
  <div class="unit-items">
    <div class="unit-title">
      <h3 class="font-weight-regular mb-0 black--text">{{ title }}</h3>
      <v-btn @click="add" class="ma-1 white" fab small light>
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>

    <draggable
      class="inner mt-5 row"
      :list="items"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
    >
      <v-col
        cols="4"
        v-for="(item, index) in items"
        :key="`unit-${index}`"
        :data-id="`${Math.round(new Date().getTime() / 1000)}`"
      >
        <benefits-card
          :item="item"
          @edit="edit"
          @remove="remove"
          :index="index"
          :attributes="attributes"
        />
      </v-col>
    </draggable>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else-if="editMode">
        <embed-form
          v-model="item"
          title="Edit an item"
          :content="content"
          :showAudience="true"
          :attributes="attributes"
          :dropdown="dropdown"
        >
          <v-btn light color="green" class="mt-10 mr-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-10 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </embed-form>
      </v-card>
      <v-card light v-else>
        <v-card-text class="">
          <embed-form
            v-model="item"
            title="Add an item"
            :content="content"
            :showAudience="true"
            :attributes="attributes"
            :dropdown="dropdown"
          >
            <v-btn light color="green" class="mt-10 mt-2 mr-2" @click="addItem"
              >Create Attribute</v-btn
            >
            <v-btn light color="white" class="mt-10 mt-2 mr-2" @click="cancel"
              >Cancel</v-btn
            >
          </embed-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
import BenefitsCard from "@/views/user/exercises/attributes/BenefitsCard";
import BenefitsMixin from "@/views/user/exercises/attributes/BenefitsMixin";
import EmbedForm from "@/views/user/exercises/attributes/EmbedForm";

export default {
  name: "BenefitsArea",
  data() {
    return {
      refs: null,
      items: this.value,
    };
  },

  mixins: [BenefitsMixin],

  props: {
    value: Array,
    name: String,
    title: String,
    dropdown: Array,
    attributes: {
      type: Array,
      default: () => [],
    },
    content: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    draggable,
    BenefitsCard,
    EmbedForm,
  },

  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },

  methods: {
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: white;
    border-radius: 5px;
    color: black;
    .icons {
      width: 50px;
      padding: 0 10px 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
.no-bullets {
  list-style: none;
  margin: 0;
  padding: 0 0 0px 5px;
  li {
    padding: 5px 0;
    border-bottom: dotted 1px #333;
  }
}
</style>
